import React, { useEffect } from "react";
export default function BubbleDocuments({ documentLink, handleDocumentLoad, renderLoading, isLoading, handleDialogToggle }) {
    // useEffect (() => {
    //     console.log(documentLink)
    // }, [documentLink]);
    return (
    <div className="fixed inset-0 flex justify-center items-center bg-black/80 backdrop-blur-sm z-50">
      <div className="relative bg-black/95 border-2 border-cyan-400/50 rounded-xl p-4 w-[90%] max-w-[1200px] h-[95%] shadow-neon-cyan backdrop-blur-md">
        {/* Cyberpunk Grid Background */}
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <div className="absolute inset-0 bg-[linear-gradient(rgba(0,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(0,255,255,0.1)_1px,transparent_1px)] bg-[size:20px_20px] animate-gridPulse"></div>
        </div>
        
        {/* Header */}
        <div className="flex justify-between items-center mb-3 relative z-10">
          <div className="flex items-center gap-3">
            <span className="text-cyan-400 font-mono text-sm font-bold">[DOCUMENT_MATRIX]</span>
          </div>
          <div className="flex space-x-2">
            <button
              className="w-3 h-3 bg-red-500 rounded-full hover:bg-red-400 transition-colors"
              onClick={() => handleDialogToggle(null)}
            ></button>
            <button
              className="w-3 h-3 bg-yellow-500 rounded-full hover:bg-yellow-400 transition-colors"
              onClick={() => handleDialogToggle(null)}
            ></button>
            <button
              className="w-3 h-3 bg-green-500 rounded-full hover:bg-green-400 transition-colors"
              onClick={() => handleDialogToggle(null)}
            ></button>
          </div>
        </div>

        {isLoading && <>{renderLoading()}</>}
        <iframe
          src={documentLink}
          width="100%"
          height="88%"
          className="rounded-lg border-2 border-cyan-400/30 shadow-neon-cyan relative z-10 bg-white"
          onLoad={handleDocumentLoad} 
        ></iframe>
        
        <div className="flex flex-row justify-between items-center mt-3 relative z-10">
          <div className="flex flex-row gap-2 items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-5 h-5 text-pink-400"
            >
              <path
                fillRule="evenodd"
                d="M6 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H6Zm1.5 1.5a.75.75 0 0 0-.75.75V16.5a.75.75 0 0 0 1.085.67L12 15.089l4.165 2.083a.75.75 0 0 0 1.085-.671V5.25a.75.75 0 0 0-.75-.75h-9Z"
                clipRule="evenodd"
              />
            </svg>
            <span className="text-pink-300 font-mono text-xs">[DOCUMENT_VIEW]</span>
          </div>
          <button
            onClick={() => handleDialogToggle(null)}
            className="group relative px-4 py-2 bg-black/60 border-2 border-red-400/50 text-red-300 hover:text-red-100 rounded-xl font-mono font-bold shadow-neon-pink hover:shadow-neon-pink-intense transition-all duration-300 transform hover:scale-105 backdrop-blur-sm overflow-hidden"
          >
            <span className="relative z-10">[CLOSE]</span>
            <div className="absolute inset-0 bg-red-400 rounded-xl transform skew-x-12 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 opacity-20"></div>
            <div className="absolute inset-0  rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-border-pulse"></div>
          </button>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute -top-1 -left-1 w-4 h-4 border-t-2 border-l-2 border-cyan-400/50 rounded-tl-xl"></div>
        <div className="absolute -top-1 -right-1 w-4 h-4 border-t-2 border-r-2 border-cyan-400/50 rounded-tr-xl"></div>
        <div className="absolute -bottom-1 -left-1 w-4 h-4 border-b-2 border-l-2 border-cyan-400/50 rounded-bl-xl"></div>
        <div className="absolute -bottom-1 -right-1 w-4 h-4 border-b-2 border-r-2 border-cyan-400/50 rounded-br-xl"></div>
      </div>
    </div>
  );
}
